
































































import Vue from 'vue';
import { Scenario, Result } from '../model';
import NumericTextField from './NumericTextField.vue';
import VarNumber from './VarNumber.vue';

export default Vue.extend({
  components: {
    NumericTextField,
    VarNumber,
  },

  props: {
    scenario: {
      type: Scenario,
      required: true,
    },
  },

  data() {
    return {
      localScenario: this.scenario,

      costAnalysisHeaders: [
        {text: '', value: 'name', sortable: false},
        {text: 'Total ($)', value: 'total'},
        {text: 'Annualized ($)', value: 'annualized', sortable: false},
        {text: 'Monthly ($)', value: 'monthly', sortable: false},
      ],
    };
  },

  methods: {
    copyScenario() {
      const obj = this.localScenario as any;
      obj.check = 'hfse0';
      const str = JSON.stringify(obj);

      // Copy to clipboard
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
  },

  computed: {
    result(): Result {
      return this.localScenario.calculate();
    },

    costAnalysisItems(): any {
      const items = [
        {
          name: 'Principal built (negative cost)',
          total: this.result.principalBuilt,
          class: 'breakdownPrincipalRow',
        }, {
          name: 'Initial and final (inc. down payment)',
          total: this.result.initialAndFinalCosts,
        }, {
          name: 'Mortgage annuity / rent',
          total: this.result.totalAnnuityAndRent,
        }, {
          name: 'Other on-going',
          total: this.result.totalOngoing - this.result.totalAnnuityAndRent,
        }, {
          name: 'Subtotal',
          total: this.result.totalCost - this.result.opportunityCost,
          class: 'breakdownSubtotalRow',
        }, {
          name: 'Investment opportunity cost',
          total: this.result.opportunityCost,
        }, {
          name: 'Total (with opportunity cost)',
          total: this.result.totalCost,
          class: 'breakdownTotalRow',
        },
      ];

      return items.map((item) => {
        return {
          name: item.name,
          class: item.class,
          total: item.total.toFixed(0),
          yearly: (item.total / this.localScenario.sellAtYear).toFixed(),
          monthly: (item.total / this.localScenario.sellAtYear / 12).toFixed(),
        };
      });
    },
  },

  watch: {
    localScenario: {
      handler(val: Scenario, old: Scenario) {
        this.$emit('editScenario', this.localScenario);
      },
      deep: true,
    },
  },
});
